import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { SpecialGuestModal } from "./SpecialGuestModal";
import {
  creatEventUrl,
  getEventDetailsUrl,
  getEventTimeZoneList,
  getEventTypeList,
  updateEventUrl,
} from "Constant/api";
import { newAuthService } from "Service/Axios";
import {
  formatDateLocal,
  getFirstLetterOfName,
  uploadHandler,
  validateTextEdiorContent,
} from "Utils";
import { useQueryParams } from "Utils/hooks";
import { Validator } from "Utils/validator";
import { DEFAULT_MODULE_TYPE, IMAGE_TYPES } from "Constant/constants";
import { paths } from "Constant/paths";
import { RichTextEditor } from "Components/RichTextEditor";
import { ImageCropper } from "Components/Modal";

const defaultEventData = {
  eventType: "",
  isPrivateEvent: "1",
  locationType: "Remote",
  inviteLink: "",
  timeZone: "",
  eventName: "",
  description: "",
  specialGuest: [],
  eventBanner: "",
  organizedBy: "",
  date: "",
  time: "",
  duration: "",
  frequency: "",
  frequencyType: "",
  frequencyEnd: "",
  registrationForm: "",
  closingDate: "",
  contactInfo: "",
  termCondition: "",
  maximumNoOfAttendee: "",
  openCommentSection: false,
  showNoOfAttendee: false,
};

export const CreateEvent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { eventId } = useQueryParams();

  const [currentStep, setCurrentStep] = useState(1);

  const [showSpecialGuestModal, setShowSpecialGuestModal] = useState(false);
  const [imageCropModal, setImageCropModal] = useState(false);
  const [eventBannerLoading, setEventBannerLoading] = useState(false);
  const [imageCropPath, setCropImagePath] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [eventTypeList, setEventTypeList] = useState([]);
  const [timeZoneList, setTimeZoneList] = useState([]);

  const [formData, setFormData] = useState(defaultEventData);
  const [errMsg, setErrMsg] = useState({
    eventType: "",
    locationType: "",
    inviteLink: "",
    timeZone: "",
    eventName: "",
    description: "",
    specialGuest: "",
    organizedBy: "",
    date: "",
    time: "",
    duration: "",
    frequency: "",
    frequencyType: "",
    frequencyEnd: "",
    closingDate: "",
    contactInfo: "",
    termCondition: "",
    maximumNoOfAttendee: "",
  });

  const {
    eventType,
    isPrivateEvent,
    locationType,
    inviteLink,
    timeZone,
    eventName,
    description,
    date,
    time,
    duration,
    specialGuest,
    eventBanner,
    organizedBy,
    frequency,
    frequencyType,
    frequencyEnd,
    registrationForm,
    closingDate,
    contactInfo,
    termCondition,
    maximumNoOfAttendee,
    openCommentSection,
    showNoOfAttendee,
  } = formData;

  // Toggle
  const toggleSpecialGuestModal = () => {
    setShowSpecialGuestModal(!showSpecialGuestModal);
  };

  const toggleImageCropModal = () => {
    setImageCropModal(!imageCropModal);
  };

  // On Change
  const handleChange = (e) => {
    if (e.target.type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.checked,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
    }

    if (e.target.name === "eventType") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          eventType: t("common.messages.error.events.eventType.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          eventType: "",
        }));
      }
    }

    if (e.target.name === "locationType") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          locationType: t("common.messages.error.events.locationType.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          locationType: "",
        }));
      }
    }

    if (e.target.name === "inviteLink") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          inviteLink: t("common.messages.error.events.inviteLink.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          inviteLink: "",
        }));
      }
    }

    if (e.target.name === "timeZone") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          timeZone: t("common.messages.error.events.timeZone.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          timeZone: "",
        }));
      }
    }

    if (e.target.name === "eventName") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          eventName: t("common.messages.error.events.eventName.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          eventName: "",
        }));
      }
    }

    if (e.target.name === "organizedBy") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          organizedBy: t("common.messages.error.events.organizedBy.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          organizedBy: "",
        }));
      }
    }

    if (e.target.name === "date") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          date: t("common.messages.error.events.date.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          date: "",
        }));
      }
    }

    if (e.target.name === "time") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          time: t("common.messages.error.events.time.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          time: "",
        }));
      }
    }

    if (e.target.name === "duration") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          duration: t("common.messages.error.events.duration.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          duration: "",
        }));
      }
    }

    if (e.target.name === "frequency") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          frequency: t("common.messages.error.events.frequency.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          frequency: "",
        }));
      }
    }

    if (e.target.name === "frequencyType") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          frequencyType: t("common.messages.error.events.frequencyType.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          frequencyType: "",
        }));
      }
    }

    if (e.target.name === "frequencyEnd") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          frequencyEnd: t("common.messages.error.events.frequencyEnd.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          frequencyEnd: "",
        }));
      }
    }

    if (e.target.name === "closingDate") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          closingDate: t("common.messages.error.events.closingDate.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          closingDate: "",
        }));
      }
    }

    if (e.target.name === "contactInfo") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          contactInfo: t("common.messages.error.events.contactInfo.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          contactInfo: "",
        }));
      }
    }

    if (e.target.name === "termCondition") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          termCondition: t("common.messages.error.events.termCondition.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          termCondition: "",
        }));
      }
    }

    if (e.target.name === "maximumNoOfAttendee") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          maximumNoOfAttendee: t(
            "common.messages.error.events.maximumNoOfAttendee.blank"
          ),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          maximumNoOfAttendee: "",
        }));
      }
    }
  };

  const handleChangeDescription = (value) => {
    const newValue = validateTextEdiorContent(value);
    setFormData((prev) => ({
      ...prev,
      description: newValue,
    }));
    if (!Validator.text(newValue)) {
      setErrMsg((prev) => ({
        ...prev,
        description: t("common.messages.error.events.description.blank"),
      }));
    } else {
      setErrMsg((prev) => ({
        ...prev,
        description: "",
      }));
    }
  };

  const handleChangeSpecialGuest = (updatedUserList) => {
    setFormData((prev) => ({
      ...prev,
      specialGuest: updatedUserList,
    }));
  };

  const handleChangeEventBanner = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageFile(file);
        setCropImagePath(reader.result);
        toggleImageCropModal();
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveEventBanner = () => {
    setFormData((prev) => ({
      ...prev,
      eventBanner: "",
    }));
  };

  // Listing
  const fetchEventTypeList = async () => {
    const payload = {};
    const response = await newAuthService(getEventTypeList, "POST", payload);
    if (response.status && response.data) {
      setEventTypeList(response.data);
    } else {
      setEventTypeList([]);
    }
  };

  const fetchTimeZoneList = async () => {
    const payload = {};
    const response = await newAuthService(
      getEventTimeZoneList,
      "POST",
      payload
    );
    if (response.status && response.data) {
      setTimeZoneList(response.data);
    } else {
      setTimeZoneList([]);
    }
  };

  useEffect(() => {
    fetchEventTypeList();
    fetchTimeZoneList();
  }, []);

  const getEventDetails = async () => {
    const payload = {
      eventId,
    };
    const response = await newAuthService(getEventDetailsUrl, "POST", payload);
    if (response.status) {
      setFormData({
        eventType: response.data.type,
        isPrivateEvent: response.data.privateEvent ? "1" : "0",
        locationType: response.data.locationType,
        inviteLink: response.data.inviteLink,
        timeZone: response.data.timezone ? response.data.timezone.gid : "",
        eventName: response.data.eventName,
        description: response.data.description,
        specialGuest: response.data.specialGuestDetails || [],
        eventBanner: response.data.banner,
        organizedBy: response.data.organizedBy,
        date: response.data.date ? formatDateLocal(response.data.date) : "",
        time: response.data.time,
        duration: response.data.duration,
        frequency: response.data.frequency,
        frequencyType: response.data.frequencyType,
        frequencyEnd: response.data.frequencyEnd,
        registrationForm: response.data.registrationForm,
        closingDate: response.data.closingDate
          ? formatDateLocal(response.data.closingDate)
          : "",
        contactInfo: response.data.contactInfo,
        termCondition: response.data.termCondition,
        maximumNoOfAttendee: response.data.maximumNoOfAttendee?.toString(),
        openCommentSection: response.data.openCommentSection,
        showNoOfAttendee: response.data.showNoOfAttendee,
      });
    } else {
      setFormData(defaultEventData);
    }
  };

  useEffect(() => {
    if (eventId) {
      getEventDetails();
    }
  }, [eventId]);

  // Validation
  const getValidation = () => {
    return new Promise((resolve) => {
      let valid = true;
      let errors = {};
      let failedStep = null;

      // Step 1 validations (always required)
      if (!Validator.text(eventType)) {
        errors.eventType = t("common.messages.error.events.eventType.blank");
        valid = false;
        if (!failedStep) failedStep = 1;
      }
      if (!Validator.text(locationType)) {
        errors.locationType = t(
          "common.messages.error.events.locationType.blank"
        );
        valid = false;
        if (!failedStep) failedStep = 1;
      }
      if (!Validator.text(inviteLink)) {
        errors.inviteLink = t("common.messages.error.events.inviteLink.blank");
        valid = false;
        if (!failedStep) failedStep = 1;
      }
      if (!Validator.text(timeZone)) {
        errors.timeZone = t("common.messages.error.events.timeZone.blank");
        valid = false;
        if (!failedStep) failedStep = 1;
      }
      if (!Validator.text(eventName)) {
        errors.eventName = t("common.messages.error.events.eventName.blank");
        valid = false;
        if (!failedStep) failedStep = 1;
      }
      if (!Validator.text(description)) {
        errors.description = t(
          "common.messages.error.events.description.blank"
        );
        valid = false;
        if (!failedStep) failedStep = 1;
      }
      if (!Validator.text(organizedBy)) {
        errors.organizedBy = t(
          "common.messages.error.events.organizedBy.blank"
        );
        valid = false;
        if (!failedStep) failedStep = 1;
      }

      // Step 2 validations (only if currentStep >= 2)
      if (currentStep >= 2) {
        if (!Validator.text(date)) {
          errors.date = t("common.messages.error.events.date.blank");
          valid = false;
          if (!failedStep) failedStep = 2;
        }
        if (!Validator.text(time)) {
          errors.time = t("common.messages.error.events.time.blank");
          valid = false;
          if (!failedStep) failedStep = 2;
        }
        if (!Validator.text(duration)) {
          errors.duration = t("common.messages.error.events.duration.blank");
          valid = false;
          if (!failedStep) failedStep = 2;
        }
        if (!Validator.text(frequency)) {
          errors.frequency = t("common.messages.error.events.frequency.blank");
          valid = false;
          if (!failedStep) failedStep = 2;
        }
        if (frequency === "Repeat") {
          if (!Validator.text(frequencyType)) {
            errors.frequencyType = t(
              "common.messages.error.events.frequencyType.blank"
            );
            valid = false;
            if (!failedStep) failedStep = 2;
          }
          if (!Validator.text(frequencyEnd)) {
            errors.frequencyEnd = t(
              "common.messages.error.events.frequencyEnd.blank"
            );
            valid = false;
            if (!failedStep) failedStep = 2;
          }
        }
      }

      // Step 3 validations (only if currentStep >= 3)
      if (currentStep >= 3) {
        if (!Validator.text(closingDate)) {
          errors.closingDate = t(
            "common.messages.error.events.closingDate.blank"
          );
          valid = false;
          if (!failedStep) failedStep = 3;
        }
        if (!Validator.text(contactInfo)) {
          errors.contactInfo = t(
            "common.messages.error.events.contactInfo.blank"
          );
          valid = false;
          if (!failedStep) failedStep = 3;
        }
        if (!Validator.text(termCondition)) {
          errors.termCondition = t(
            "common.messages.error.events.termCondition.blank"
          );
          valid = false;
          if (!failedStep) failedStep = 3;
        }
        if (!Validator.text(maximumNoOfAttendee)) {
          errors.maximumNoOfAttendee = t(
            "common.messages.error.events.maximumNoOfAttendee.blank"
          );
          valid = false;
          if (!failedStep) failedStep = 3;
        }
      }

      // Set errors once
      setErrMsg((prev) => ({
        ...prev,
        ...errors,
      }));

      // If not valid, set current step to the failed step
      if (!valid && failedStep && failedStep !== currentStep) {
        setCurrentStep(failedStep);
      }

      resolve(valid);
    });
  };

  // Submit & Reset
  const handleBack = () => {
    setCurrentStep((prev) => prev - 1);
  };

  const handleNext = async () => {
    const validationStatus = await getValidation();
    if (validationStatus) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const handleSaveEventBanner = async (_, cropFile) => {
    setEventBannerLoading(true);
    const mockEvent = {
      target: {
        files: [cropFile],
      },
    };
    const response = await uploadHandler(
      mockEvent,
      DEFAULT_MODULE_TYPE.event,
      IMAGE_TYPES
    );
    if (response && response.url) {
      setFormData((prev) => ({
        ...prev,
        eventBanner: response.url,
      }));
    } else {
      setEventBannerLoading(false);
    }
  };

  const handleSubmit = async () => {
    const validationStatus = await getValidation();
    if (validationStatus) {
      const timeZoneObj = timeZoneList.find((zone) => zone.gid === timeZone);

      try {
        const payload = {
          status: "draft",
          type: eventType,
          privateEvent: isPrivateEvent === "1",
          locationType,
          inviteLink,
          timezone: timeZoneObj
            ? {
                gid: timeZoneObj?.gid || "",
                name: timeZoneObj?.name || "",
              }
            : null,
          eventName,
          description,
          specialGuest: specialGuest.map((guest) => guest.userId),
          banner: eventBanner,
          organizedBy,
          date,
          time,
          duration,
          frequency,
          frequencyType,
          frequencyEnd,
          registrationForm,
          closingDate,
          contactInfo,
          termCondition,
          maximumNoOfAttendee,
          openCommentSection,
          showNoOfAttendee,
        };
        if (eventId) {
          payload.eventId = eventId;
        }
        const response = await newAuthService(
          eventId ? updateEventUrl : creatEventUrl,
          "POST",
          payload
        );
        if (response.status && response.data) {
          navigate(`${paths.admin.events.details}/${response.data.eventId}`);
          toast.success(
            eventId
              ? t("common.messages.notification.success.updateEvent")
              : t("common.messages.notification.success.createEvent")
          );
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        toast.error(
          t("common.messages.notification.failed.somethingWentWrong")
        );
      }
    }
  };

  return (
    <main className="main">
      <div className="mb-4">
        <div className="p-3 rounded-3 bg-white position-relative">
          <div className="d-flex flex-wrap align-items-center row-gap-3 mb-3">
            <div className="">
              <h3 className="text-md font-semibold mb-0">Create Your Event</h3>
            </div>
          </div>

          <div className="">
            <div className="d-flex justify-content-center">
              <ul className="event-step-list list-unstyled d-inline-flex justify-content-center p-4 bg-slate-50 rounded-2">
                <li className={`pt-10 px-5 position-relative active`}>
                  <span className="font-medium text-slate-400">
                    Basic Details
                  </span>
                </li>
                <li
                  className={`pt-10 px-5 position-relative ${
                    currentStep >= 2 ? "active" : " "
                  }`}
                >
                  <span className="font-medium text-slate-400">
                    Location & Accessibility
                  </span>
                </li>
                <li
                  className={`pt-10 px-5 position-relative ${
                    currentStep >= 3 ? "active" : " "
                  }`}
                >
                  <span className="font-medium text-slate-400">
                    Final Touches
                  </span>
                </li>
              </ul>
            </div>
            <div className="d-flex align-items-center mb-3">
              <h3 className="me-3 mb-0 text-sm text-nowrap text-grey-700">
                {currentStep === 1
                  ? "Basic Details"
                  : currentStep === 2
                  ? "Location & Accessibility"
                  : "Final Touches"}
              </h3>
              <div className="bg-slate-200 w-100 h-1"></div>
            </div>

            {currentStep === 1 && (
              <Row>
                <Col lg={6} md={12} sm={12} xs={12}>
                  <div className="mb-3">
                    <label htmlFor="eventType" className="form-label">
                      Type of Event
                    </label>
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      id="eventType"
                      name="eventType"
                      value={eventType || ""}
                      onChange={handleChange}
                    >
                      <option value="">Select Event Type</option>
                      {eventTypeList.length > 0 &&
                        eventTypeList.map((eventType) => (
                          <option key={eventType.gid} value={eventType.gid}>
                            {eventType.name}
                          </option>
                        ))}
                    </select>
                    {errMsg.eventType && (
                      <p className="error">{errMsg.eventType}</p>
                    )}
                  </div>
                </Col>
                <Col lg={6} md={12} sm={12} xs={12}>
                  <div className="mb-3">
                    <label htmlFor="" className="form-label">
                      Is this event Private or Public?
                    </label>
                    <div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="isPrivateEvent"
                          id="privateEvent"
                          value="1"
                          checked={isPrivateEvent === "1"}
                          onChange={handleChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="privateEvent"
                        >
                          Private
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="publicEvent"
                          name="isPrivateEvent"
                          value="0"
                          checked={isPrivateEvent === "0"}
                          onChange={handleChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="publicEvent"
                        >
                          Public
                        </label>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg={4} md={12} sm={12} xs={12}>
                  <div className="mb-3">
                    <label htmlFor="locationType" className="form-label">
                      Location Type
                    </label>
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      id="locationType"
                      name="locationType"
                      value={locationType || ""}
                      onChange={handleChange}
                      disabled
                    >
                      <option value="">Select Location Type</option>
                      <option value="Remote">Remote</option>
                    </select>
                    {errMsg.locationType && (
                      <p className="error">{errMsg.locationType}</p>
                    )}
                  </div>
                </Col>
                <Col lg={4} md={12} sm={12} xs={12}>
                  <div className="mb-3">
                    <label htmlFor="inviteLink" className="form-label">
                      Invite Link (Zoom or Google Meet)
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      id="inviteLink"
                      name="inviteLink"
                      value={inviteLink}
                      onChange={handleChange}
                    />
                    {errMsg.inviteLink && (
                      <p className="error">{errMsg.inviteLink}</p>
                    )}
                  </div>
                </Col>
                <Col lg={4} md={12} sm={12} xs={12}>
                  <div className="mb-3">
                    <label htmlFor="timeZone" className="form-label">
                      Select Timezone
                    </label>
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      id="timeZone"
                      name="timeZone"
                      value={timeZone || ""}
                      onChange={handleChange}
                    >
                      <option value="">Select Timezone</option>
                      {timeZoneList?.length > 0 &&
                        timeZoneList.map((timeZone) => (
                          <option key={timeZone.gid} value={timeZone.gid}>
                            {timeZone.name}
                          </option>
                        ))}
                    </select>
                    {errMsg.timeZone && (
                      <p className="error">{errMsg.timeZone}</p>
                    )}
                  </div>
                </Col>
                <Col lg={12} md={12} sm={12} xs={12}>
                  <div className="mb-3">
                    <label htmlFor="eventName" className="form-label">
                      Name of the Event
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      id="eventName"
                      name="eventName"
                      value={eventName}
                      onChange={handleChange}
                    />
                    {errMsg.eventName && (
                      <p className="error">{errMsg.eventName}</p>
                    )}
                  </div>
                </Col>
                <Col lg={12} md={12} sm={12} xs={12}>
                  <div className="mb-3">
                    <label htmlFor="description" className="form-label">
                      Event Description
                    </label>
                    <RichTextEditor
                      value={description}
                      onChange={handleChangeDescription}
                    />
                    {errMsg.description && (
                      <p className="error">{errMsg.description}</p>
                    )}
                  </div>
                </Col>
                <Col lg={12} md={12} sm={12} xs={12}>
                  <div className="mb-3">
                    <div className="d-flex align-items-center">
                      <div className="d-flex flex-column row-gap-2">
                        <label className="form-label mb-0">
                          Add Special Guest / Speaker or Honorable Attendees
                        </label>
                        <div className="d-flex flex-wrap gap-2">
                          {specialGuest?.length > 0 &&
                            specialGuest.map((guest, guestIndex) => (
                              <div
                                className="p-1 rounded-pill d-flex align-items-center bg-slate-100 position-relative"
                                key={guestIndex.toString()}
                              >
                                <button
                                  type="button"
                                  className="label-close w-4 h-4 rounded-circle border-0 bg-slate-200 position-absolute d-flex justify-content-center align-items-center"
                                >
                                  <i className="bx bx-x"></i>
                                </button>
                                <div className="w-10 h-10 rounded-circle overflow-hidden flex-none me-2 border border-white">
                                  {guest.photoURL ? (
                                    <img
                                      src={guest.photoURL}
                                      alt={`${guest.firstName}${guest.lastName}`}
                                      className="w-100 h-100 object-fit-cover"
                                    />
                                  ) : (
                                    getFirstLetterOfName(guest)
                                  )}
                                </div>
                                <span className="text-xs font-medium text-slate-500 me-3">
                                  {guest.firstName} {guest.lastName}
                                </span>
                              </div>
                            ))}
                        </div>
                      </div>
                      <div className="ms-auto">
                        <button
                          type="button"
                          className="w-10 h-10 d-flex justify-content-center align-items-center rounded-circle border bg-transparent"
                          onClick={toggleSpecialGuestModal}
                        >
                          <i className="bx bx-user-plus bx-sm"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg={12} md={12} sm={12} xs={12}>
                  <div className="mb-3">
                    <label htmlFor="organizedBy" className="form-label">
                      Organized by
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter your name"
                      id="organizedBy"
                      name="organizedBy"
                      value={organizedBy}
                      onChange={handleChange}
                    />
                    {errMsg.organizedBy && (
                      <p className="error">{errMsg.organizedBy}</p>
                    )}
                  </div>
                </Col>
                <Col lg={12} md={12} sm={12} xs={12}>
                  <div className="mb-3">
                    <label htmlFor="eventBanner" className="form-label">
                      Add Event Banner
                    </label>
                    <div className="file-input-box bg-white border rounded position-relative overflow-hidden">
                      {eventBanner ? (
                        <div className="p-3">
                          <div className="position-relative mx-auto image-ratio-4-1">
                            <img
                              src={eventBanner}
                              alt="Event Banner Preview"
                              className="rounded-lg w-100 h-100 object-fit-cover"
                            />
                            <button
                              type="button"
                              onClick={handleRemoveEventBanner}
                              className="w-6 h-6 d-flex justify-content-center align-items-center rounded-circle border border-grey-200 bg-white position-absolute banner-thumb-close"
                            >
                              <i className="bx bx-x text-lg"></i>
                            </button>
                          </div>
                        </div>
                      ) : (
                        <>
                          <label
                            htmlFor="file"
                            className="d-block p-5 text-center"
                          >
                            {/* <span className="material-symbols-outlined">
                              cloud_upload
                            </span>
                            <h6 className="mb-0 text-grey-700">
                              Upload your Banner
                            </h6> */}
                            <i className="bx bx-image-add text-10xl"></i>
                            <h5 class="mb-0 text-sm">
                              <span className="font-medium">Choose file</span>{" "}
                              or <span className="font-medium">Drag here</span>
                            </h5>
                            {/* <small>File Size 20 MB</small> */}
                          </label>
                          <input
                            type="file"
                            id="eventBanner"
                            className="position-absolute top-0 start-0 bottom-0 end-0 opacity-0"
                            onChange={handleChangeEventBanner}
                          />
                        </>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            )}

            {currentStep === 2 && (
              <Row>
                <Col lg={4} md={4} sm={4} xs={12}>
                  <div className="mb-3">
                    <label htmlFor="date" className="form-label">
                      Date
                    </label>
                    <input
                      className="form-control"
                      type="date"
                      placeholder=""
                      id="date"
                      name="date"
                      value={date}
                      onChange={handleChange}
                    />
                    {errMsg.date && <p className="error">{errMsg.date}</p>}
                  </div>
                </Col>
                <Col lg={4} md={4} sm={4} xs={12}>
                  <div className="mb-3">
                    <label htmlFor="time" className="form-label">
                      Time
                    </label>
                    <input
                      className="form-control"
                      type="time"
                      placeholder=""
                      id="time"
                      name="time"
                      value={time}
                      onChange={handleChange}
                    />
                    {errMsg.time && <p className="error">{errMsg.time}</p>}
                  </div>
                </Col>
                <Col lg={4} md={4} sm={4} xs={12}>
                  <div className="mb-3">
                    <label htmlFor="duration" className="form-label">
                      Duration
                    </label>
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      id="duration"
                      name="duration"
                      value={duration || ""}
                      onChange={handleChange}
                    >
                      <option value="">Select Duration of the Event</option>
                      <option value="15 minutes">15 minutes</option>
                      <option value="30 minutes">30 minutes</option>
                      <option value="45 minutes">45 minutes</option>
                      <option value="1 hour">1 hour</option>
                      <option value="1 hour 30 minutes">
                        1 hour 30 minutes
                      </option>
                    </select>
                    {errMsg.duration && (
                      <p className="error">{errMsg.duration}</p>
                    )}
                  </div>
                </Col>
                <Col lg={4} md={4} sm={4} xs={12}>
                  <div className="mb-3">
                    <label htmlFor="frequency" className="form-label">
                      Frequency of Event
                    </label>
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      id="frequency"
                      name="frequency"
                      value={frequency || ""}
                      onChange={handleChange}
                    >
                      <option value="">Select Frequency of Event</option>
                      <option value="Once">Once</option>
                      <option value="Repeat">Repeat</option>
                    </select>
                    {errMsg.frequency && (
                      <p className="error">{errMsg.frequency}</p>
                    )}
                  </div>
                </Col>
                <Col lg={4} md={4} sm={4} xs={12}>
                  <div className="mb-3">
                    <label htmlFor="frequencyType" className="form-label">
                      Every
                    </label>
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      id="frequencyType"
                      name="frequencyType"
                      value={frequencyType || ""}
                      onChange={handleChange}
                      disabled={frequency === "Once"}
                    >
                      <option value="">Select Repeat Every</option>
                      <option value="1 Week">1 Week</option>
                      <option value="2 Weeks">2 Weeks</option>
                      <option value="3 Weeks">3 Weeks</option>
                      <option value="4 Weeks">4 Weeks</option>
                    </select>
                    {errMsg.frequencyType && (
                      <p className="error">{errMsg.frequencyType}</p>
                    )}
                  </div>
                </Col>
                <Col lg={4} md={4} sm={4} xs={12}>
                  <div className="mb-3">
                    <label htmlFor="frequencyEnd" className="form-label">
                      End after (Occurrence)
                    </label>
                    <select
                      className="form-select"
                      aria-label="End after (Occurrence)"
                      id="frequencyEnd"
                      name="frequencyEnd"
                      value={frequencyEnd || ""}
                      onChange={handleChange}
                      disabled={frequency === "Once"}
                    >
                      <option value="">Select End after (Occurrence)</option>
                      {Array.from({ length: 10 }, (_, val) => (
                        <option key={val + 1} value={val + 1}>
                          {val + 1}
                        </option>
                      ))}
                    </select>
                    {errMsg.frequencyEnd && (
                      <p className="error">{errMsg.frequencyEnd}</p>
                    )}
                  </div>
                </Col>
              </Row>
            )}

            {currentStep === 3 && (
              <Row>
                <Col lg={12} md={12} sm={12} xs={12}>
                  <div className="mb-3">
                    <label htmlFor="registrationForm" className="form-label">
                      Event Registration Form Number
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      placeholder={t("common.placeHolder.registrationForm")}
                      id="registrationForm"
                      name="registrationForm"
                      value={registrationForm}
                      onChange={handleChange}
                    />
                  </div>
                </Col>
                <Col lg={12} md={12} sm={12} xs={12}>
                  <div className="mb-3">
                    <label htmlFor="closingDate" className="form-label">
                      Registration Closing date
                    </label>
                    <input
                      className="form-control"
                      type="date"
                      placeholder="Enter your name"
                      id="closingDate"
                      name="closingDate"
                      value={closingDate}
                      onChange={handleChange}
                    />
                    {errMsg.closingDate && (
                      <p className="error">{errMsg.closingDate}</p>
                    )}
                  </div>
                </Col>
                <Col lg={12} md={12} sm={12} xs={12}>
                  <div className="mb-3">
                    <label htmlFor="contactInfo" className="form-label">
                      Contact Information for Queries
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      id="contactInfo"
                      name="contactInfo"
                      value={contactInfo}
                      onChange={handleChange}
                    />
                    {errMsg.contactInfo && (
                      <p className="error">{errMsg.contactInfo}</p>
                    )}
                  </div>
                </Col>
                <Col lg={12} md={12} sm={12} xs={12}>
                  <div className="mb-3">
                    <label htmlFor="termCondition" className="form-label">
                      Terms & Condition
                    </label>
                    <textarea
                      className="form-control"
                      placeholder=""
                      id="termCondition"
                      name="termCondition"
                      value={termCondition}
                      onChange={handleChange}
                    ></textarea>
                    {errMsg.termCondition && (
                      <p className="error">{errMsg.termCondition}</p>
                    )}
                  </div>
                </Col>
                <Col lg={12} md={12} sm={12} xs={12}>
                  <div className="mb-3">
                    <label htmlFor="maximumNoOfAttendee" className="form-label">
                      Maximum no. of attendees allowed
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      placeholder=""
                      id="maximumNoOfAttendee"
                      name="maximumNoOfAttendee"
                      value={maximumNoOfAttendee}
                      onChange={handleChange}
                    />
                    {errMsg.maximumNoOfAttendee && (
                      <p className="error">{errMsg.maximumNoOfAttendee}</p>
                    )}
                  </div>
                </Col>
                <Col lg={12} md={12} sm={12} xs={12}>
                  <div className="mb-3">
                    <div className="d-flex align-items-center">
                      <label className="form-label mb-0">
                        Show No of Attendees in the event?
                      </label>
                      <div className="ms-auto">
                        <div className="form-check form-switch form-switch-lg d-flex align-items-center justify-content-between form-switch-right form-switch-success">
                          <label className="text-sm font-medium">No</label>
                          <input
                            className="form-check-input mt-0 mx-2"
                            type="checkbox"
                            role="switch"
                            id="showNoOfAttendee"
                            name="showNoOfAttendee"
                            checked={showNoOfAttendee}
                            onChange={handleChange}
                          />
                          <label className="text-sm font-medium">Yes</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            )}

            <div className="mt-2 d-flex flex-wrap gap-2 justify-content-center">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleBack}
                disabled={currentStep === 1}
              >
                Back
              </button>

              <button
                type="button"
                className="btn btn-secondary"
                onClick={currentStep === 3 ? handleSubmit : handleNext}
              >
                {currentStep === 3 ? "Submit" : "Next Step"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {showSpecialGuestModal && (
        <SpecialGuestModal
          show={showSpecialGuestModal}
          selectGuestIds={specialGuest.map((guest) => guest.userId)}
          toggle={toggleSpecialGuestModal}
          handleChangeSpecialGuest={handleChangeSpecialGuest}
        />
      )}

      {imageCropModal && (
        <ImageCropper
          isLoading={eventBannerLoading}
          show={imageCropModal}
          imageFile={imageFile}
          src={imageCropPath}
          aspectRatio={4 / 1}
          toggle={toggleImageCropModal}
          handleCrop={handleSaveEventBanner}
        />
      )}
    </main>
  );
};
